import React, { Component, Fragment } from "react";
import { Modal, Button, Message, Icon, Popup, Input } from "semantic-ui-react";

import PositiveMessage from "../components/PositiveMessage";
import NegativeMessage from "../components/ErrorMessage";

import UsersTable from "../components/UsersTable";
import { escapeQuotes } from "../../store/functionUtils";

import { connect } from "react-redux";
import {
  resetUserToAdd,
  saveUserToAdd,
} from "../../store/actions/AdministrationActions";
import client from "../../store/apolloClient";
import gql from "graphql-tag";

class AddUserModal extends Component {
  constructor(props) {
    super(props);
    this.child = React.createRef();
    this.state = {
      done: false,
      error: false,
      loading: false,
      userToAdd: -1,
      users: [],
      userSearch: "",
      selectedRoleID: -1,
    };
  }
  addUser() {
    const selectedRole = this.props.roles.filter(
      (role) => role.id === this.state.selectedRoleID
    )[0];

    const mutation = gql`
      mutation addUserToTeam {
        insert_simcaa_t_userxteam(objects: {
          iduser: ${this.state.userToAdd},
            idteam: ${this.props.currentTeam},
            role_id: ${selectedRole.id},
            user_permissions: "${escapeQuotes(
              JSON.parse(selectedRole.role_permissions)
            )}"
          }) {
            affected_rows
          }
        }
        `;

    this.setState({ loading: true });
    client.mutate({ mutation }).then((data) => {
      this.setState({ loading: false });
      if (data.hasOwnProperty("errors")) {
        //errors in creating the association user->team
        this.setState({ done: false, error: true });
      } else {
        //no errors, all ok
        this.setState({ done: true, error: false });
      }
    });
    // .catch((error)=>{
    //   this.setState({done:false, error:true, loading:false})
    // })
  }

  // componentDidMount() {
  //   this.props.saveUserToAddToStore(
  //     this.props.user.idstaff,
  //     this.props.currentTeam
  //   );
  //   this.setState({ users: this.props.user_to_add });
  // }

  changeRole(roleID) {
    this.setState({ selectedRoleID: roleID });
  }

  userSelected(id) {
    this.setState({ userToAdd: id }, () => {
      this.forceUpdate();
    });
  }

  resetSearch() {
    // this.props.saveUserToAddToStore(
    //   this.props.user.idstaff,
    //   this.props.currentTeam
    // );
    this.setState({ userSearch: "", userToAdd: -1, selectedRoleID: -1 });
    this.child.current.clicked(-1);
    this.props.resetUserToAdd();
  }

  searchUser() {
    const query = gql`
      {
        simcaa_t_userxteam(
          distinct_on: iduser,
          where: {
            _and: [{ idteam: { _neq: ${this.props.currentTeam} }, 
                user: { idstaff: { _eq: ${this.props.user.idstaff} } }
                _or: [{user: {user: {_ilike: "${this.state.userSearch}"}}},
                  {user: {email: {_eq: "${this.state.userSearch}"}}}]
              }]
          }
        ) {
          role_id
          user {
            name
            user
            id
            email
            organization
            link_web
          }
          role {
            weight
          }
        }
        simcaa_t_users(where: { userxteam: { idteam: { _eq: ${this.props.currentTeam} } } }) {
          id
        }
      }
    `;

    this.props.saveUserToAddToStore(null, null, query);
  }

  getModalContent() {
    if (!this.state.done && !this.state.error) {
      //user yet to Search
      return (
        <Fragment>
          <p>
            Seleziona l'utente da inserire nel team, ti basta cliccare sulla sua
            riga
          </p>
          <hr />
          <Input
            placeholder="username o email da cercare"
            value={this.state.userSearch}
            onChange={(e) => this.setState({ userSearch: e.target.value })}
          />
          <Button color="blue" onClick={this.searchUser.bind(this)}>
            Cerca
          </Button>
          <Button color="blue" onClick={this.resetSearch.bind(this)}>
            Resetta ricerca
          </Button>
          <UsersTable
            users={this.props.user_to_add}
            userSelected={this.userSelected.bind(this)}
            roles={this.props.roles}
            selectable={true}
            manageUsers={false}
            loggedUser={this.props.user}
            selectedRole={this.state.selectedRoleID}
            changeRole={this.changeRole.bind(this)}
            // modUser={() => {
            //   return null;
            // }}
            // removeUser={() => {
            //   return null;
            // }}
            ref={this.child}
          />
          <Message positive hidden={this.state.userToAdd === -1 ? true : false}>
            <p>Hai selezionato l'utente con id: {this.state.userToAdd}</p>
          </Message>
        </Fragment>
      );
    } else if (this.state.done) {
      //user added to team
      return (
        <PositiveMessage
          header="Tutto ok!"
          message="L'utente è stato aggiunto correttamente al team :)"
          hidden={false}
        />
      );
    } else if (this.state.error) {
      //errors in the operation
      return (
        <NegativeMessage
          header="Errore!"
          message="L'utente non è stato aggiunto al team, riprova più tardi :("
          hidden={false}
        />
      );
    }
  }

  render() {
    const teamName = this.props.teams.filter(
      (item) => item.id === this.props.currentTeam
    )[0].name;
    let contentLayout = this.getModalContent();
    return (
      <Modal
        closeIcon="close"
        open={this.props.openModal}
        onClose={this.props.closeModal}
      >
        <Modal.Header>
          Aggiunta di un utente per il team {teamName}
          <Popup
            trigger={<Icon name="help" style={{ float: "right" }} />}
            content={
              "In questa tabella sono mostrati gli utenti del sistema che non appartengono al team " +
              teamName +
              ", cliccando sulla riga di un utente questi verrà selezionato, per aggiungerlo in questo team basterà poi cliccare su Aggiungi."
            }
          />
        </Modal.Header>
        <Modal.Content>{contentLayout}</Modal.Content>
        <Modal.Actions>
          <Button negative onClick={() => this.props.closeModal()}>
            Chiudi
          </Button>
          {!this.state.done && !this.state.error ? (
            <Button
              positive
              loading={this.state.loading}
              disabled={
                this.state.userToAdd === -1 || this.state.selectedRoleID === -1
                  ? true
                  : false
              }
              onClick={() => this.addUser()}
            >
              Aggiungi Utente
            </Button>
          ) : null}
        </Modal.Actions>
      </Modal>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    user_to_add: state.adminReducer.user_to_add,
    roles: state.adminReducer.roles,
    currentTeam: state.modalReducer.toTeam,
    user: state.user,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    saveUserToAddToStore: (staff_id, notInTeam, queryUser) =>
      dispatch(saveUserToAdd(staff_id, notInTeam, queryUser)),
    resetUserToAdd: () => dispatch(resetUserToAdd()),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(AddUserModal);



// WEBPACK FOOTER //
// ./src/administration/containers/AddUserModal.js